module.exports = __webpack_public_path__ + "static/media/decticus_verrucivorus_002_APA.d289b3fd.png";